export interface IAppConfig {
  readonly authorization_endpoint: string;
  readonly token_endpoint: string;
  readonly user_info_endpoint: string;
  readonly end_session_endpoint: string;
  readonly redirect_uri: string;
  readonly client_id: string;
  readonly response_type: string;
  readonly scope: string;
  readonly api_endpoint: string;
  readonly fel_endpoint: string;
  readonly asds_endpoint: string;
}

export interface IEnvVars {
  CLIENT_ID: string;
  API_ENDPOINT: string;
  FEL_ENDPOINT: string;
  ASDS_ENDPOINT: string;
}

export const DEV_HOSTNAME =
  "apm-settings-tool-gviuutly-dev-dskmulis.apps.dev.aks.honaero.com";
export const QA_HOSTNAME = "apm-settings-tool-ui.qaerospace1.honeywellaerospace.com";
export const PROD_HOSTNAME = "apm-settings-tool-ui.aerospace1.honeywellaerospace.com";

export const getEnvVariables = (
  hostName: string = window.location.hostname
): { envVars: IEnvVars; issuerBaseURL: string } => {
  let envEnvVars: IEnvVars;
  let issuerBaseURL: string;

  switch (hostName) {
    case DEV_HOSTNAME:
      envEnvVars = require("./DEV_ENV_VARS").default;
      issuerBaseURL = "https://identity-qa.honeywellaerospace.com";
      break;
    case QA_HOSTNAME:
      envEnvVars = require("./QA_ENV_VARS").default;
      issuerBaseURL = "https://identity-qa.honeywellaerospace.com";
      break;
    case PROD_HOSTNAME:
      envEnvVars = require("./PROD_ENV_VARS").default;
      issuerBaseURL = "https://identity.honeywellaerospace.com";
      break;
    default:
      envEnvVars = require("./LOCAL_ENV_VARS").default;
      issuerBaseURL = "https://identity-qa.honeywellaerospace.com";
  }

  return { envVars: envEnvVars, issuerBaseURL };
};

const { envVars, issuerBaseURL } = getEnvVariables();

export const appConfig: IAppConfig = {
  authorization_endpoint: `${issuerBaseURL}/oauth2/auth`,
  token_endpoint: `${issuerBaseURL}/oauth2/token`,
  user_info_endpoint: `${issuerBaseURL}/userinfo`,
  end_session_endpoint: `${issuerBaseURL}/oauth2/sessions/logout`,
  redirect_uri: `${window.location.origin}/authorize`,
  client_id: envVars.CLIENT_ID,
  response_type: "code",
  scope: "openid customersub forge.access",
  api_endpoint: envVars.API_ENDPOINT,
  fel_endpoint: envVars.FEL_ENDPOINT,
  asds_endpoint: envVars.ASDS_ENDPOINT,
};
